<script setup lang="ts">
const emit = defineEmits<{ close: [] }>()

const props = defineProps<{
  onConfirm: () => void
}>()

function confirm() {
  props.onConfirm()
  emit('close')
}

function cancel() {
  emit('close')
}
</script>

<template>
  <UiAlertDialog :open="true">
    <UiAlertDialogContent>
      <UiAlertDialogTitle class="text-4xl">
        {{ $t('Undo bull winner') }}
      </UiAlertDialogTitle>
      <UiAlertDialogFooter>
        <UiButton
          variant="success"
          size="huge"
          class="mr-auto"
          @click="confirm"
        >
          {{ $t('Yes') }}
        </UiButton>
        <UiButton
          variant="destructive"
          size="huge"
          @click="cancel"
        >
          {{ $t('No') }}
        </UiButton>
      </UiAlertDialogFooter>
    </UiAlertDialogContent>
  </UiAlertDialog>
</template>
